module.exports = __webpack_public_path__ + "img/SecretCharm.a9b27176.jpg";